import { dataLayerFormAction } from '../../js/utils/dataLayers';
import formValues from './FormValues';

const customForm = document.querySelector('.kentico-extended-form-block .custom-form-wrapper');

const FullPageFormObserverInitializer = () => {
    if (customForm) {
        const observer = new MutationObserver(FullPageFormObserverCallback);

        observer.observe(customForm, { childList: true });

        const dataLayerFormName = customForm.dataset.formName;
        formValues(customForm, dataLayerFormName);

        GiveKenticoSelectPlaceholder();
    }
};

const FullPageFormObserverCallback = () => {
    // Special for complaint form (show / hide the privacy worning)
    const checkboxConfidentialFeedback = document.querySelector('input[id*="IsFeedbackConfidential_Value"]');
    const fullnameInput = document.querySelector('input[id*="FullName_Value"]');
    const privacyWarning = document.querySelector('.notification-confidential');

    const dataLayerFormName = customForm.dataset.formName;
    formValues(customForm, dataLayerFormName);

    if (privacyWarning) {
        if (!checkboxConfidentialFeedback) {
            privacyWarning.classList.toggle('hidden', true);
        } else {
            privacyWarning.classList.toggle('hidden', !!(fullnameInput));
        }
    }

    const submitResultSuccess = document.querySelector('.kentico-extended-form-block .custom-form-wrapper .formwidget-submit-text');
    const notificationSuccess = document.querySelector('.kentico-extended-form-block .custom-form-wrapper .notification-success');
    const submitResultError = document.querySelector('.kentico-extended-form-block .custom-form-wrapper .formwidget-error');
    const notificationError = document.querySelector('.kentico-extended-form-block .custom-form-wrapper .notification-error');

    if (submitResultSuccess && notificationSuccess) {
        notificationSuccess.classList.toggle('hidden', !submitResultSuccess);
        notificationSuccess.scrollIntoView(true);
        dataLayerFormAction(dataLayerFormName, 'complete', false);
    } else if (submitResultError && notificationError) {
        notificationError.classList.toggle('hidden', !submitResultError);
        notificationError.scrollIntoView(true);

        // From submission error message
        const errorMessage = submitResultError.textContent;
        dataLayerFormAction(dataLayerFormName, 'error', errorMessage);
    }

    // Form Validation Error
    const fieldErrors = customForm
        .querySelectorAll('.ktc-radio-list + .field-validation-error, .ktc-checkbox + .field-validation-error, .input-validation-error + .field-validation-error');
    if (fieldErrors.length > 0) {
        for (let i = 0; i < fieldErrors.length; i += 1) {
            const errorMessage = fieldErrors[i].textContent;
            dataLayerFormAction(dataLayerFormName, 'error', errorMessage);
        }
    }

    // general, for all form.
    GiveKenticoSelectPlaceholder();
};

const GiveKenticoSelectPlaceholder = () => {
    const allSelects = document.querySelectorAll('.kentico-extended-form-block .custom-form-wrapper select');

    allSelects.forEach(selectField => {
        const firstOpt = selectField.querySelector('option');
        if (firstOpt) {
            firstOpt.setAttribute('value', '');
            firstOpt.setAttribute('disabled', '');
        }
    });
};

document.addEventListener('DOMContentLoaded', FullPageFormObserverInitializer);
